export default __webpack_public_path__ + "static/media/3.06830e41.png";